import * as React from 'react';
import type { ProjectId } from 'owa-timestream-types';

const ProjectIdContext = React.createContext<ProjectId>('' as ProjectId);
ProjectIdContext.displayName = 'ProjectIdContext';

/** Projects that need ProjectId must import it from the SDK, never from the store! */
export type { ProjectId };

/**
 * This export is used by the canvas, so it can specify which project is being rendered.
 */
export const ProjectIdProvider = ProjectIdContext.Provider;

/**
 * Hook that return the ID of the Project being rendered.
 */
export function useProjectId() {
    return React.useContext(ProjectIdContext);
}
